/**
 @Developper: BenAli Faker
 @Company: SMART-INFO
 @Post: CTO
 @Date:30/07/2021
 @Time:07:02
 **/
import i18next from "i18next";
import Http from 'i18next-http-backend';
import I18NextChainedBackend from "i18next-chained-backend";
import I18NextLocalStorageBackend from "i18next-localstorage-backend";
import BackendAdapter from "i18next-multiload-backend-adapter";
import resourcesToBackend from "i18next-resources-to-backend";
import LangueService from "./LangueService";
export default class TranslationService {


    /**
     * les namespace de traduction disponible pour Begro
     * @type {string[]}
     */
    #translationNamespaces = Object.freeze([
        'front-office',
        'paiement',
        "societe",
        'inventaire',
        'produit',
        'stock',
        'commun',
        'list',
        'bon_sortie',
        'bon_livraison',
        'vente',
        'achat',
        'file'
    ]);
    /**
     * L'espace de traduction par défaut si aucun namespace est définit pour i18n
     * @type {Readonly<string>}
     */
    #defaultTranslationNamespace = Object.freeze("commun");


    /**
     *
     * @type {boolean}
     * @private
     */
    #_initialized=false;

    /**
     * pile des fonctions a exécuter à l'initialisation de i18next
     * @type {function[]}
     * @private
     */
    #_listOnInitializeCallback=[];




    /**
     * Singleton Translation service
     */
    static #instance;

    /**
     * Translator i18next
     * @type {i18n}
     */
    #_translator;


    /**
     * @description Le constructeur va retourner toujours la même instance puisque c'est singleton
     * @return {*}
     */
    constructor() {
        if (TranslationService.#instance == null) {
            Begro.logInfo("Initialisation de service de traduction...")
            TranslationService.#instance = this;
            this.#initializeWebTranslatorService();
            Begro.logInfo("Fin Initialisation de service de traduction...")
        }
        return TranslationService.#instance;
    }

    /**
     *
     * @return {TranslationService}
     */
    static getInstance() {
        return TranslationService.#instance||new TranslationService();// elle va retourner toujours la même instance voir constructeur
    }


    /**
     *
     * @return {i18n}
     */
    get translator() {
        return this.#_translator;
    }


    #initializeWebTranslatorService() {
        let translationService=this;
        this.#_translator = i18next;
        let langue = LangueService.getInstance().activeLangue.langue;
        this.#_translator.use(I18NextChainedBackend).init({
            fallbackLng: 'fr',
            lng: langue,
            ns: this.#translationNamespaces,
            defaultNS: this.#defaultTranslationNamespace,
            debug: Begro.isDevMode(),
            backend: {
                backends: [
                    I18NextLocalStorageBackend,  // primaire -recherche dans la cache de navigateur
                    Http             // si cache ne contient pas on load les fichiers de traductions via http
                ],
                backendOptions: [{
                      // option de cache voir https://github.com/i18next/i18next-localstorage-backend
                    },
                    {
                        allowMultiLoading: false,
                        loadPath: Begro.getURL('js/locales/{{lng}}/{{ns}}.json'),
                        addPath: Begro.getURL('js/locales/{{lng}}/{{ns}}.json'),
                    }
                    ]
            }
        }).then(function (t) {
            Begro.logInfo("i18next est initialisé et prêt a être utiliser");
            Begro.logInfo("exécution des function retardés jusqu'a initialisation de service de traduction");
            translationService.#_initialized=true;
            Begro.logInfo("TraductionService : La pile d'éxcution séquentielle contient: "+translationService.#_listOnInitializeCallback.length)
            for(let index in translationService.#_listOnInitializeCallback)
            {
                translationService.#_listOnInitializeCallback[index](translationService);
            }
            translationService.#_listOnInitializeCallback=[];

        });
    }

    /**
     * Effectue un translation d'un message
     * @param {String} key le clé de traduction
     * @param {{}=} remplacements tableau json des mots a remplacer
     * @param {String} context le contexte de remplacement
     */
     translate(key, remplacements = {}, context = null) {
        let options = {};
        if (context !== null && typeof context === "string") {
            Begro.logInfo(`TraductionService :context de traduction de ${key} est ${context}`);
            options['context'] = context;
        }
        let keys = Object.keys(remplacements);
        if (keys.length > 0) {
            for (let key in remplacements) {
                options[key] = remplacements[key];
            }
        }
        Begro.logInfo(`TranslationService: clé de traduction est ${key} et  les options  qui seront envoyés a i18next sont :`,options);
        return TranslationService.getInstance().translator.t(key,options);

    }


    /**
     * @param {function(TranslationService)} functionCallback fonction de callback qui sera exécuté une fois on prêt a traduire
     */
    whenInitialized(functionCallback){
         if(!this.#_initialized){//différé et seront exécuté des que le service sera prêt a utiliser
             this.#_listOnInitializeCallback.push(functionCallback);
         }else{//exécution immédiat
            functionCallback(this);
         }
    }
}
$(function(){
    TranslationService.getInstance();
});